import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { CONFIG_KEYS, StateService } from '@services/state.service';
import { ensureArray, isJsObject, parseDec, unsub } from '@util/utils';
import { DataService } from '@data/data.service';
import { TeamDateComponent } from '../team-date/team-date.component';
import {
  dayNames,
  isValidDate,
  strToDate,
  toRequestDate,
  weekDayNames,
} from '@util/date-utils';
import {
  createCalendarWeeks,
} from '@util/calendar-utils';
import { BackendPaths } from '@common/backend-paths';
import { NotificationService } from '@notification/notification.service';

let planId = 1;
let datePlanId = 1;

export interface TeamPlanData {
  team: any;
  order: any;
  sub: Subject<any>;
}

function newDatePlanId() {
  datePlanId++;
  return datePlanId;
}

@Component({
  selector: 'app-team-plan',
  templateUrl: './team-plan.component.html',
})
export class TeamPlanComponent implements OnDestroy, OnInit {

  isDialog = false;

  colors: any = {};

  completeColors: any = {};

  dayNames = dayNames;

  names: any = weekDayNames;

  searchText = '';

  team: any = {};

  weeks: any[] = [];

  id: string | number = '';

  isAdmin: boolean | null = false;

  dialogStyle: any = {
    'display': 'flex',
    'flex-direction': 'column',
    'min-height': '75vh'
  };

  componentContentStyle: any = {
    'overflow': 'auto'
  };

  dialogContentStyle: any = {
    overflow: 'scroll',
    //'flex': 1,
    padding: '0.5rem 1rem',
    height: '55vh'
  };

  adminSub!: Subscription;
  routeSub!: Subscription;
  configChangeSub?: Subscription;

  startDate!: Date | string;

  endDate!: Date | string;

  order: any;

  team_name = '';

  currentNamesOfDays: string[] = [];

  dateChanged = false;

  repetiveGetDataCall = false;
  isLoading = false;

  constructor(
    @Optional() public dialogRef: MatDialogRef<TeamPlanComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: TeamPlanData,
    private dataService: DataService,
    private matDialog: MatDialog,
    private stateService: StateService,
    private currentRoute: ActivatedRoute,
    private router: Router,
    public notificationService: NotificationService
  ) {
    planId++;
    this.id = 'em' + planId;

    for (let n of this.dayNames) {
      this.colors[n] = [n + '-dark', n + '-light'];
      this.completeColors[n] = [n + '-complete-dark', n + '-complete-light'];
    }

    if (isJsObject(data)) {
      this.isDialog = true;
    }
  }

  ngOnInit(): void {
    this.isAdmin = this.stateService.isAdmin();

    this.adminSub = this.stateService
      .adminChange()
      .subscribe((change: boolean | null) => {
        this.isAdmin = change;
      });

    this.setSearchDates();

    this.configChangeSub = this.stateService.configChange().subscribe((e: any) => {
      this.setSearchDates();
    });

    /*
    let sd: any;
    const wd = data?.order?.work_day;

    if (wd && typeof wd === 'string') {
      sd = strToDate(wd);
    } else if (wd instanceof Date) {
      sd = wd;
    }

    if (sd instanceof Date) {
      this.startDate = sd;
    } else {
      this.startDate = new Date();
    }

    const end = addMonths(this.startDate, 1);

    this.endDate = end;
    */

    if (this.isDialog) {
      this.order = this.data.order;

      if (this.data.team?.id) {
        this.id = this.data.team?.id;
        if (this.data.team.first_name) {
          this.team_name = 'Team: ' + this.data.team.first_name + ' ' +
            this.data.team.last_name;
        }
      } else {

      }

      this.getData();
    } else {
      this.routeSub = this.currentRoute.params.subscribe((param: Params) => {
        if (param.id) {
          this.id = parseDec(param.id);
        }
        this.getData();
      });
    }
  }

  ngOnDestroy(): void {
    this.configChangeSub = unsub(this.configChangeSub);
    this.routeSub && this.routeSub.unsubscribe();

    this.adminSub.unsubscribe();
  }

  setSearchDates() {
    const startDate = this.stateService.getConfigurationFor(
      CONFIG_KEYS.TEAM_PLAN_START_DATE
    );

    const endDate = this.stateService.getConfigurationFor(
      CONFIG_KEYS.TEAM_PLAN_END_DATE,
      startDate
    );

    if (!this.dateChanged) {
      this.startDate = startDate;

      this.endDate = endDate;
    }
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

  onDateChange($event: any) {
    if ($event && isValidDate($event)) {
      return $event;
    }
    return null;
  }

  onStartDateChange($event: any) {
    const res = this.onDateChange($event);
    this.startDate = res;
    this.dateChanged = true;
  }

  onEndDateChange($event: any) {
    const res = this.onDateChange($event);
    this.endDate = res;
    this.dateChanged = true;
  }

  currentDate(d: any) {
    if (d) {
      if (d instanceof Date) {
        return d;
      }
      return strToDate(d);
    }
    return null;
  }

  currentStartDate() {
    return this.currentDate(this.startDate);
  }

  currentEndDate() {
    return this.currentDate(this.endDate);
  }



  getData() {
    if (this.id) {
      const url = BackendPaths.DATES_FULL + this.id;

      const options: any = {
        text: this.searchText
      };

      const s = toRequestDate(this.startDate);
      if (s) {
        options.from = s;
      }
      const e = toRequestDate(this.endDate);
      if (e) {
        options.to = e;
      }

      if (this.repetiveGetDataCall) {

      }

      this.isLoading = true;

      this.dataService.get(url, options).subscribe((data: any) => {

        const content = data?.result;

        if (content.success) {
          const dates = ensureArray(content.dates);

          if (content.team) {
            this.team = content.team;
          }

          if (!dates.length) {
            const current = new Date();
            dates.push({
              dates: [],
              y: current.getFullYear(),
              m: current.getMonth() + 1,
              d: current.getDate(),
              current: true,
              dummy: true,
            });
          }

          this.setDates(dates);
        } else {
          const errors = ensureArray(content.errors);
          if (!errors.length) {
            errors.push('Fehler beim Laden der Termine')
          }
          this.notificationService.showErrors(errors);
        }
        this.isLoading = false;
      }, (err: any) => {
        this.isLoading = false;
      });
    }
    this.repetiveGetDataCall = true;
  }

  setDates(dates: any[]) {
    const weeksRes = createCalendarWeeks(
      dates,
      this.currentStartDate(),
      this.currentEndDate(),
      true
    );

    const optionalDayNames: string[] = [];//['saturday', 'sunday'];

    const toRemove: string[] = [];
    const weeks = weeksRes.weeks;

    for (let dn of optionalDayNames) {
      let has = false;
      for (let w of weeks) {
        let d = w[dn];
        if (d && d.dates?.length > 0) {
          has = true;
          break;
        }
      }
      if (!has) {
        toRemove.push(dn);
      }
    }

    let currentNamesOfDays = weeksRes.dayNames;

    if (toRemove.length > 0) {
      currentNamesOfDays = currentNamesOfDays.filter((name: string) => {
        return toRemove.indexOf(name) < 0;
      });
    }
    this.currentNamesOfDays = currentNamesOfDays;
    this.weeks = weeks;

    //console.log('WEEKS:', weeks);
  }

  get currentDayNames() {
    return this.currentNamesOfDays.length > 0
      ? this.currentNamesOfDays
      : this.dayNames;
  }

  editDate(week: any, dow: any, date: any) {

    if (week && dow && week[dow] && date) {
      if (!this.isAdmin) {
        //MyLog.log('Go to order', date.order);
        this.router.navigate(['/orders/' + date.order.id]);
        return;
      }

      const data: any = {
        d: date.d + '.' + date.m + '.' + date.y,
        order: date.order,
      };

      this.openDateDialog(data).subscribe((result: any) => {
        result && this.getData();
      });
    }
  }

  addDate() {
    this.add(null, null, new Date());
  }

  add(week: any, day: any, date?: any) {
    const data: any = {};

    if (this.team) {
      data.name = this.team.first_name + ' ' + this.team.last_name;
      data.team = this.team;
    }

    if (week) {
      const weekDay = week[day];
      if (!weekDay) {
        console.error('Fehler');
        return;
      }
      if (weekDay.date) {
        data.d = weekDay.date;
      }
    }

    if (date) {
      data.d = date;
    }

    data.order = this.order;

    if (data.order && !data.order.id) {
      data.order.datePlanId = newDatePlanId();
    }

    if (this.isDialog) {
      data.fixedOrder = true;
    }

    this.openDateDialog(data).subscribe((result: any) => {
      if (result) {
        if (this.isDialog) {
          this.data.sub.next(result);
        }

        this.getData();
      }
    });
  }

  openDateDialog(data: any) {
    return this.matDialog
      .open(TeamDateComponent, {
        data: data,
        disableClose: false,
        autoFocus: false
      })
      .afterClosed();
  }

  onSearchChange($event: any) {
    this.searchText = $event;
  }

  search() {
    this.getData();
  }
}
